import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, tap } from 'rxjs/operators';
import { SeoActions } from '../actions/seo.actions';
import { EMPTY } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { BASE_TITLE } from '../../constants/general.contants';

@Injectable()
export class SeoEffects {
  $setTitle = createEffect(() =>
    this.actions$.pipe(
      ofType(SeoActions.SEO_SET_TITLE),
      tap((action: { title: string }) => {
        this.titleService.setTitle(`${action.title} | ${BASE_TITLE}`);
      }),
    ),
    { dispatch: false }
  );

  $setDescription = createEffect(() =>
    this.actions$.pipe(
      ofType(SeoActions.SEO_SET_DESCRIPTION),
      tap(({ description }) => {
        this.metaService.updateTag({
          name: 'description',
          content: description,
        });
      }),
    ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private titleService: Title,
    private metaService: Meta,
  ) {}
}
